module.exports = "<p>\n  test works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/event/test/test.component.html
// module id = ../../../../../src/app/event/test/test.component.html
// module chunks = main